var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArticle = function SvgArticle(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M873.69.52h-351.9a95.08 95.08 0 0 0-67.55 28L28.47 454.28a95.54 95.54 0 0 0 0 135.1l382.18 382.17a95.51 95.51 0 0 0 135.09 0l425.77-425.76a95.08 95.08 0 0 0 28-67.55v-351.9A125.82 125.82 0 0 0 873.69.52M778.58 308a86.52 86.52 0 1 1 86.52-86.51A86.48 86.48 0 0 1 778.58 308"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArticle);
export default ForwardRef;